import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Phone, MapPin, Menu, X, Check, ArrowRight, ChevronDown, Star, MessageCircle } from "lucide-react";
import { useState, useEffect } from "react";

// Original site images
const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/5mpnbfee_IMG_0645.jpeg",
  heroSecond: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/ndnc6ybn_IMG_0641.jpeg",
  fullBody: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/j7asnlp1_site%20colocar.png",
  faceNeck: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/kgxz7726_nova%20imagem.png",
  bikini: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/v575rwns_Gemini_Generated_Image_wvritgwvritgwvri.png",
  pauloWithMachine: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/ito583rm_IMG_1834.jpeg",
  studioView: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/kn9gctw5_IMG_1851.jpeg",
  treatmentArea: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/ucpi4rxp_IMG_1849.jpeg",
  products: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/5ghjbrz2_IMG_1780.jpeg",
  treatmentBed: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/gryvnpa3_IMG_1858.jpeg",
  clinicRoom: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/r5cpzhjo_IMG_1848.jpeg",
  fullRoom: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/dslr6xb0_IMG_1845.jpeg",
  hairPoster: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/d9f5dei2_DSC_5020.JPG",
  pauloPortrait: "https://customer-assets.emergentagent.com/job_skinlaserclinic/artifacts/ziruet75_IMG_1831.jpeg",
  // NEW photos
  treatment1: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/s2gumvps_IMG_0645.jpeg",
  ledTherapy1: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/x6qru7gw_IMG_0644.jpeg",
  ledTherapy2: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/q91d42h6_IMG_0642.jpeg",
  beardTreatment: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/alylkq9k_IMG_0648.jpeg",
  facialTreatment: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/q7fgmasl_IMG_0640.jpeg",
  pauloNew: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/lvucn656_IMG_1831.jpeg",
  pauloExpert: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/86j655oa_Founder.png",
  beforeAfter: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/im3ss4jl_Before%20and%20After%20Youtube%20Thumbnail%20Cityscape.png",
  beforeAfter2: "https://customer-assets.emergentagent.com/job_team-story-update/artifacts/8187hxo2_Before%20and%20After%20Youtube%20Thumbnail%20Cityscape.png",
  clinicRoom: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-story-update/artifacts/95c5ig4x_E665CCCE-67BC-4C1D-8B6D-5003DFB76046.webp",
};

// Meo Logo Component - using official logo image
const MeoLogo = ({ className = "" }) => (
  <Link to="/" className={`block ${className}`} data-testid="meo-logo">
    <img 
      src="https://customer-assets.emergentagent.com/job_team-story-update/artifacts/kcqcruhz_IMG_1875.png" 
      alt="Meo Laser & Skin - London" 
      className="h-16 w-auto object-contain"
      style={{ 
        filter: 'brightness(0) saturate(100%) invert(48%) sepia(8%) saturate(1051%) hue-rotate(346deg) brightness(91%) contrast(87%)'
      }}
    />
  </Link>
);

// Flashing Top Banner
const TopBanner = () => (
  <div className="bg-gradient-to-r from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] py-3 text-center overflow-hidden">
    <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap px-4">
      <span className="text-white font-bold text-xs md:text-sm tracking-wider">✓ VIRTUALLY PAIN-FREE TREATMENTS</span>
      <span className="text-[#25D366] font-bold hidden md:inline">|</span>
      <span className="text-white font-bold text-xs md:text-sm tracking-wider">✓ ADVANCED TECHNOLOGY WITH PERSONALISED SETTINGS</span>
      <span className="text-[#25D366] font-bold hidden md:inline">|</span>
      <span className="text-white font-bold text-xs md:text-sm tracking-wider">✓ SUITABLE LASER OPTIONS FOR DIFFERENT SKIN TYPES</span>
    </div>
  </div>
);

// Navigation Component
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/pricing", label: "Pricing" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <nav className="sticky top-0 left-0 right-0 z-50 bg-[#F9F9F7]">
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          <div className="flex flex-col items-start">
            <MeoLogo />
            {/* Big WhatsApp Button under logo */}
            <a
              href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation%20and%20get%20the%2030%25%20off%20offer."
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 flex items-center gap-2 px-5 py-2.5 bg-[#25D366] text-white rounded-full font-bold text-base hover:bg-[#20BD5A] transition-all hover:scale-105 shadow-lg"
              data-testid="nav-whatsapp-btn"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Us Now!
            </a>
            {/* 30% Off Badge */}
            <div className="mt-2 bg-red-600 text-white px-4 py-2 rounded-full font-bold text-sm animate-bounce">
              🔥 30% OFF TODAY - SPOTS LIMITED!
            </div>
          </div>
          
          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-wide transition-colors ${
                  location.pathname === link.path
                    ? "text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="nav-book-btn"
            >
              BOOK NOW
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-foreground p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isOpen && (
          <div className="md:hidden pt-4 pb-2 border-t border-border mt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-sm ${
                  location.pathname === link.path ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary block text-center mt-4"
            >
              BOOK NOW
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

// WhatsApp Button
const WhatsAppButton = () => (
  <a
    href="https://wa.me/447767323343"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-btn"
    aria-label="Book via WhatsApp"
    data-testid="whatsapp-floating-btn"
  >
    <MessageCircle size={28} />
  </a>
);

// Home Page
const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="min-h-screen flex items-center relative overflow-hidden" data-testid="hero-section">
        <div className="container-custom pt-24 pb-20 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
            <div className="space-y-8 animate-fade-in-up">
              <div className="space-y-4">
                <h1 className="text-heading-xl">
                  Laser Hair Removal Bank London | Meo Laser & Skin – <span className="text-[#C4A484]">30% OFF</span> First Sessions <span className="text-lg block mt-2 text-muted-foreground">(Limited Time)</span>
                </h1>
                <p className="text-xl text-muted-foreground mt-2">Comfortable, virtually pain-free</p>
              </div>
              <div className="text-body max-w-lg space-y-4">
                <h2 className="font-heading text-2xl">Advanced Laser Hair Removal in Bank, London</h2>
                <p>Meo Laser & Skin is a private laser clinic in the heart of the City of London, specialising in advanced laser hair removal for men and women.</p>
                <p>We use the DEKA Motus Pro, featuring Alexandrite and Nd:YAG technology, to provide personalised treatments for different skin types.</p>
                <p>Located just a 5-minute walk from Bank Station, our private studio offers a comfortable and discreet environment.</p>
                
                <h3 className="font-heading text-xl pt-2">Our treatments</h3>
                <div className="space-y-3">
                  <div>
                    <p className="font-semibold text-[#C4A484]">Laser hair removal for men</p>
                    <p className="text-muted-foreground">Back, chest, shoulders, beard and other areas.</p>
                  </div>
                  <div>
                    <p className="font-semibold text-[#C4A484]">Laser hair removal for women</p>
                    <p className="text-muted-foreground">Legs, underarms, bikini and other areas.</p>
                  </div>
                </div>
                
                {/* Clinic Location */}
                <div className="pt-4 border-t border-gray-200 mt-4">
                  <h3 className="font-heading text-xl">Visit Meo Laser & Skin London</h3>
                  <p className="font-medium mt-2">14–16 Dowgate Hill, London, EC4R 2SU</p>
                  <p className="text-muted-foreground">Near Bank Station, Cannon Street and Mansion House.</p>
                  <p className="text-[#C4A484] font-medium mt-1">Appointments by booking only</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <a
                  href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20FREE%20consultation."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary flex items-center justify-center gap-2"
                  data-testid="hero-book-btn"
                >
                  BOOK CONSULTATION <ArrowRight size={16} />
                </a>
                <span className="text-[#C4A484] font-medium text-sm border border-[#C4A484] px-4 py-2 rounded-full">
                  FREE CONSULTATION
                </span>
                <Link
                  to="/pricing"
                  className="btn-secondary flex items-center justify-center gap-2"
                  data-testid="hero-pricing-btn"
                >
                  VIEW PRICING
                </Link>
              </div>
              <div className="flex items-center gap-4 flex-wrap">
                <a 
                  href="tel:+447767323343" 
                  className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="hero-call-link"
                >
                  <Phone size={18} />
                  <span>Call us: +44 7767 323 343</span>
                </a>
                <span className="text-[#25D366] font-bold text-lg bg-[#25D366]/20 px-5 py-2 rounded-full border-2 border-[#25D366] animate-pulse">
                  🎉 Get 30% OFF Today!
                </span>
              </div>
            </div>
            <div className="relative animate-fade-in-up animation-delay-200">
              {/* New Treatment Session Video - TOP */}
              <div className="mb-6">
                <div className="rounded-3xl overflow-hidden bg-gray-200 shadow-2xl">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-[450px] object-cover"
                    data-testid="hero-video-3"
                  >
                    <source src="https://storage.googleapis.com/byc-main-storage/files/fd741f41-3b79-4315-a246-28c0249f933a/IMG_1955-1791663623778.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <p className="text-center text-sm text-muted-foreground mt-3 italic">
                  Watch a real advanced laser hair removal session using the DEKA Motus Pro + Zimmer Cryo System
                </p>
              </div>
              {/* Clinic Photo */}
              <div className="rounded-3xl overflow-hidden shadow-2xl mb-6">
                <img
                  src={IMAGES.clinicRoom}
                  alt="Meo Laser Clinic - Treatment Room with Motus Pro"
                  className="w-full h-[350px] object-cover"
                  data-testid="clinic-image"
                />
              </div>
              {/* Treatment Videos */}
              <div className="grid grid-cols-2 gap-4">
                <div className="rounded-3xl overflow-hidden bg-gray-200">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster={IMAGES.hero}
                    className="w-full h-[400px] object-cover"
                    data-testid="hero-video-1"
                  >
                    <source src="https://customer-assets.emergentagent.com/job_team-story-update/artifacts/xut93582_persona-video12.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="rounded-3xl overflow-hidden mt-12 bg-gray-200">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster={IMAGES.heroSecond}
                    className="w-full h-[400px] object-cover"
                    data-testid="hero-video-2"
                  >
                    <source src="https://customer-assets.emergentagent.com/job_team-story-update/artifacts/9r15pdl7_persona-video15.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
              {/* Meet the Expert - Under Photos */}
              <div className="mt-6 flex justify-center">
                <a
                  href="https://wa.me/447767323343?text=Hi%20Paulo!%20I%27d%20like%20to%20book%20a%20consultation."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block hover:scale-105 transition-transform duration-300"
                >
                  <img
                    src={IMAGES.pauloExpert}
                    alt="Meet the Expert - Paulo Roberto - Click to WhatsApp"
                    className="max-w-sm w-full rounded-2xl shadow-lg cursor-pointer"
                    data-testid="expert-hero-image"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section-padding bg-muted" data-testid="services-section">
        <div className="container-custom">
          <div className="text-center mb-16 space-y-4 animate-fade-in-up">
            <p className="text-sm uppercase tracking-widest text-muted-foreground">Our Services</p>
            <h2 className="text-heading-lg">Treatment <span className="italic">Areas</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { img: IMAGES.fullBody, title: "Full Body", desc: "Complete laser hair removal for silky smooth skin from head to toe.", bgColor: "bg-[#8a9a8a]" },
              { img: IMAGES.faceNeck, title: "Face & Neck", desc: "Precision treatments for delicate facial areas with lasting results." },
              { img: IMAGES.bikini, title: "Bikini & Buttocks", desc: "Comfortable and effective treatments for intimate areas." },
            ].map((service, index) => (
              <div key={index} className="card-stone p-0 overflow-hidden animate-fade-in-up" data-testid={`service-card-${index}`} style={{ animationDelay: `${index * 100}ms` }}>
                <div className={`img-hover overflow-hidden h-64 ${service.bgColor || ''}`}>
                  <img 
                    alt={service.title} 
                    className={`w-full h-full ${service.bgColor ? 'object-contain' : 'object-cover'}`} 
                    src={service.img} 
                  />
                </div>
                <div className="p-8 space-y-4">
                  <h3 className="font-heading text-2xl">{service.title}</h3>
                  <p className="text-body text-sm">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link to="/pricing" className="btn-primary inline-flex items-center gap-2" data-testid="services-view-all-btn">
              View All Treatments <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section-padding" data-testid="benefits-section">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8 animate-fade-in-up">
              <div className="space-y-4">
                <p className="text-sm uppercase tracking-widest text-muted-foreground">Why Choose Us</p>
                <h2 className="text-heading-lg">The Meo <span className="italic">Difference</span></h2>
              </div>
              <p className="text-body">
                We combine cutting-edge technology with personalized care to deliver exceptional results. 
                Our clinic is designed for your comfort and privacy.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  "FDA-approved laser technology",
                  "Experienced certified specialists",
                  "Comfortable & private environment",
                  "Customized treatment plans",
                  "Advanced laser technology for long-term hair reduction",
                  "Suitable laser options for different skin types",
                  "Visible results may develop over a course of treatments"
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center gap-3 animate-fade-in-up" data-testid={`benefit-${index}`} style={{ animationDelay: `${index * 50}ms` }}>
                    <div className="w-6 h-6 rounded-full bg-[#D1D9D1] flex items-center justify-center flex-shrink-0">
                      <Check size={14} />
                    </div>
                    <span className="text-sm">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="img-hover rounded-3xl overflow-hidden animate-fade-in-up animation-delay-200 bg-[#f5f5f0]">
              <img
                alt="Paulo Roberto with DEKA Laser Machine"
                className="w-full h-[400px] lg:h-[500px] object-contain"
                data-testid="benefits-image"
                src={IMAGES.pauloWithMachine}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Gallery Section */}
      <section className="section-padding" data-testid="treatment-gallery-section">
        <div className="container-custom">
          <div className="text-center mb-12 space-y-4 animate-fade-in-up">
            <p className="text-sm uppercase tracking-widest text-muted-foreground">Our Treatments</p>
            <h2 className="text-heading-lg">Advanced <span className="italic">Technology</span></h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            <div className="relative group overflow-hidden rounded-2xl aspect-square">
              <img src={IMAGES.treatment1} alt="Laser hair removal treatment" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium">Laser Hair Removal</span>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl aspect-square">
              <img src={IMAGES.ledTherapy1} alt="LED light therapy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium">LED Light Therapy</span>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl aspect-square">
              <img src={IMAGES.ledTherapy2} alt="LED treatment" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium">Skin Rejuvenation</span>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl aspect-square">
              <img src={IMAGES.beardTreatment} alt="Beard treatment" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium">Face & Neck</span>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl aspect-square">
              <img src={IMAGES.facialTreatment} alt="Facial treatment" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium">Facial Treatments</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Reviews Section */}
      <section className="section-padding bg-[#2C2C2C] text-white" data-testid="reviews-section">
        <div className="container-custom">
          <div className="text-center mb-16 space-y-4 animate-fade-in-up">
            <div className="flex items-center justify-center gap-3 mb-4">
              <svg viewBox="0 0 24 24" className="w-8 h-8">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span className="text-2xl font-bold text-white">Google Reviews</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={24} className="text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <span className="text-xl font-semibold text-white">5.0</span>
              <span className="text-white/60">• Based on customer reviews</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Review 1 - Igor */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4 animate-fade-in-up" data-testid="review-igor">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#4285F4] flex items-center justify-center text-white font-bold text-lg">I</div>
                <div>
                  <p className="font-semibold text-white">Igor</p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={14} className="text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-white/80 leading-relaxed text-sm">
                "I had a great experience at Meo Laser! Paulo has created such a welcoming and professional clinic right here in London. From the moment you walk in, you can tell everything is done with care and attention to detail. Paulo is incredibly knowledgeable, takes the time to explain the process, and makes you feel completely at ease. The treatment itself was smooth, efficient, and completely pain-free thanks to the modern laser technology he uses. I was genuinely surprised at how comfortable it was. If you're looking for high-quality laser hair removal with someone you can genuinely trust, I highly recommend Meo Laser."
              </p>
            </div>

            {/* Review 2 - Cristiane */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4 animate-fade-in-up" data-testid="review-cristiane" style={{ animationDelay: '100ms' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#34A853] flex items-center justify-center text-white font-bold text-lg">C</div>
                <div>
                  <p className="font-semibold text-white">Cristiane Mota Tambani</p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={14} className="text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-white/80 leading-relaxed text-sm">
                "A very cozy and welcoming space! Paulo is extremely friendly and very professional. I had laser hair removal and already saw results after the second session. Highly recommend!"
              </p>
            </div>

            {/* Review 3 - Rajeh */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4 animate-fade-in-up" data-testid="review-rajeh" style={{ animationDelay: '200ms' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#FBBC05] flex items-center justify-center text-white font-bold text-lg">R</div>
                <div>
                  <p className="font-semibold text-white">Rajeh Kumar</p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={14} className="text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-white/80 leading-relaxed text-sm">
                "I recently visited Meo Laser and Skin London, and I couldn't be happier. The staff were welcoming, professional, and attentive. My laser treatment was quick, effective, and virtually painless. The clinic itself is clean, modern, and very calming. I've already noticed a big improvement in my skin, and I will definitely be returning for more treatments."
              </p>
            </div>

            {/* Review 4 - Hannah */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4 animate-fade-in-up" data-testid="review-hannah" style={{ animationDelay: '300ms' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#EA4335] flex items-center justify-center text-white font-bold text-lg">H</div>
                <div>
                  <p className="font-semibold text-white">Hannah</p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={14} className="text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-white/80 leading-relaxed text-sm">
                "I had an amazing experience at Meo Laser and Skin London. The staff were professional, friendly, and made me feel completely at ease. The laser treatment was painless, and the results were noticeable almost immediately. The clinic is spotless and very welcoming. I would highly recommend Meo Laser and Skin to anyone looking for high-quality skin treatments!"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" data-testid="cta-section">
        <div className="container-custom">
          <div className="bg-muted rounded-3xl p-12 lg:p-20 text-center space-y-8 animate-fade-in-up">
            <h2 className="text-heading-lg">Ready to Start Your <span className="italic">Journey?</span></h2>
            <p className="text-body max-w-xl mx-auto">
              Book your free consultation today and discover how we can help you achieve 
              the smooth, hair-free skin you've always wanted.
            </p>
            <a
              href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2"
              data-testid="cta-book-btn"
            >
              Book Free Consultation <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>

      {/* Frequently Asked Questions */}
      <section className="section-padding" data-testid="home-faq-section">
        <div className="container-custom max-w-4xl">
          <div className="text-center mb-12 space-y-4 animate-fade-in-up">
            <p className="text-sm uppercase tracking-widest text-muted-foreground">FAQ</p>
            <h2 className="text-heading-lg">Frequently Asked <span className="italic">Questions</span></h2>
          </div>
          
          <div className="space-y-6">
            <div className="card-stone p-6">
              <h3 className="font-heading text-lg mb-2">Where is Meo Laser & Skin located?</h3>
              <p className="text-muted-foreground">We are located at 14–16 Dowgate Hill, London, EC4R 2SU, a short walk from Bank Station.</p>
            </div>
            
            <div className="card-stone p-6">
              <h3 className="font-heading text-lg mb-2">Do you offer laser hair removal for men?</h3>
              <p className="text-muted-foreground">Yes. We offer laser hair removal for men, including treatments for the back, chest, shoulders and beard area.</p>
            </div>
            
            <div className="card-stone p-6">
              <h3 className="font-heading text-lg mb-2">Which laser machine do you use?</h3>
              <p className="text-muted-foreground">We use the DEKA Motus Pro, with Alexandrite and Nd:YAG laser technology.</p>
            </div>
            
            <div className="card-stone p-6">
              <h3 className="font-heading text-lg mb-2">How many laser hair removal sessions will I need?</h3>
              <p className="text-muted-foreground">The number of sessions varies depending on the treatment area, hair characteristics and individual response. A personalised treatment plan is provided after assessment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Find Us Section */}
      <section className="section-padding bg-muted" data-testid="find-us-section">
        <div className="container-custom">
          <div className="text-center mb-12 space-y-4 animate-fade-in-up">
            <p className="text-sm uppercase tracking-widest text-muted-foreground">Find Us</p>
            <h2 className="text-heading-lg">Visit Our <span className="italic">Studio</span></h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="space-y-6 animate-fade-in-up">
              <div className="card-stone p-8 space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-[#D1D9D1] flex items-center justify-center flex-shrink-0">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl mb-2">Our Address</h3>
                    <p className="text-muted-foreground">14-16 Dowgate Hill</p>
                    <p className="text-muted-foreground">London EC4R 2SU</p>
                  </div>
                </div>
                <div className="pt-4 border-t border-border">
                  <p className="text-sm text-muted-foreground">
                    Just a few meters from Bank Station — easily accessible by tube.
                  </p>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=14-16+Dowgate+Hill+London+EC4R+2SU"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary inline-flex items-center gap-2 w-full justify-center"
                  data-testid="get-directions-btn"
                >
                  Get Directions <ArrowRight size={16} />
                </a>
              </div>
            </div>
            <div className="animate-fade-in-up animation-delay-200 rounded-2xl overflow-hidden h-[350px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.1234567890123!2d-0.0903!3d51.5118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876034b8e8e8e8e%3A0x1234567890abcdef!2s14-16%20Dowgate%20Hill%2C%20London%20EC4R%202SU!5e0!3m2!1sen!2suk!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Meo Laser & Skin Studio Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// About Page - UPDATED with new content
const About = () => {
  const galleryImages = [
    { src: IMAGES.treatment1, alt: "Laser treatment session" },
    { src: IMAGES.ledTherapy1, alt: "LED light therapy" },
    { src: IMAGES.ledTherapy2, alt: "LED treatment closeup" },
    { src: IMAGES.beardTreatment, alt: "Beard treatment" },
    { src: IMAGES.facialTreatment, alt: "Facial treatment" },
    { src: IMAGES.studioView, alt: "Studio view" },
    { src: IMAGES.treatmentArea, alt: "Treatment area" },
    { src: IMAGES.products, alt: "Products" },
    { src: IMAGES.treatmentBed, alt: "Treatment bed" },
    { src: IMAGES.clinicRoom, alt: "Clinic room" },
  ];

  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="pt-32 pb-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6 animate-fade-in-up">
              <p className="text-sm uppercase tracking-widest text-muted-foreground">About Us</p>
              <h1 className="text-heading-xl" data-testid="about-title">
                Your Trusted Partner in Laser Hair Removal in London Bank Area
              </h1>
              <p className="text-body" data-testid="about-text-1">
                Meo Laser & Skin Studio was created with a clear purpose: to deliver advanced laser 
                and skin treatments with precision, safety, and exceptional results.
              </p>
              <a
                href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center gap-2"
                data-testid="about-book-btn"
              >
                Book Consultation <ArrowRight size={16} />
              </a>
            </div>
            <div className="grid grid-cols-2 gap-4 animate-fade-in-up animation-delay-200">
              <img src={IMAGES.treatment1} alt="Laser treatment" className="rounded-2xl w-full h-48 object-cover" />
              <img src={IMAGES.ledTherapy1} alt="LED therapy" className="rounded-2xl w-full h-48 object-cover mt-8" />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-8 overflow-hidden">
        <div className="flex gap-4 overflow-x-auto pb-4 px-4 scrollbar-hide">
          {galleryImages.map((img, index) => (
            <div key={index} className="flex-shrink-0 w-48 h-48 rounded-xl overflow-hidden">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </section>

      {/* Languages */}
      <section className="py-12">
        <div className="container-custom">
          <p className="text-center text-sm text-muted-foreground mb-6">Your Comfort Languages</p>
          <div className="flex justify-center gap-8 flex-wrap">
            {[
              { flag: "🇬🇧", lang: "English" },
              { flag: "🇮🇹", lang: "Italian" },
              { flag: "🇧🇷", lang: "Brazilian Portuguese" },
              { flag: "🇪🇸", lang: "Spanish" },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl mb-2">{item.flag}</div>
                <div className="text-sm text-muted-foreground">{item.lang}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-muted">
        <div className="container-custom">
          <div className="flex justify-center gap-16 flex-wrap">
            <div className="text-center" data-testid="stat-treatments">
              <div className="text-5xl font-heading text-foreground">5,000+</div>
              <div className="text-sm text-muted-foreground mt-2">Treatments Done</div>
            </div>
            <div className="text-center" data-testid="stat-satisfaction">
              <div className="text-5xl font-heading text-foreground">99%</div>
              <div className="text-sm text-muted-foreground mt-2">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story - UPDATED */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Our Story</p>
            <h2 className="text-heading-lg">The Art of Perfect <span className="italic">Skin</span></h2>
          </div>
          <div className="max-w-3xl mx-auto space-y-6 text-body">
            <p data-testid="story-text-1">
              Founded by Paulo Roberto, a London-based laser specialist, the studio reflects a 
              passion for aesthetics, technology, and skin health. At 37 years old, Paulo brings 
              a modern, client-focused approach, combining technical expertise with personalised care.
            </p>
            <p data-testid="story-text-2">
              Paulo completed professional training in Laser Hair Removal and Tattoo Removal 
              in London, following UK safety standards and best clinical practices.
            </p>
            <p data-testid="story-text-3">
              Every treatment is performed with attention to detail, comfort, and results, 
              using advanced technology to ensure safe and effective outcomes for all skin types.
            </p>
            <p data-testid="story-text-4">
              At Meo Laser & Skin Studio, we believe in natural results, confidence, 
              and the art of perfect skin. Each client receives a bespoke consultation 
              and treatment plan, ensuring a tailored experience in a discreet, professional, 
              and welcoming environment.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-padding bg-muted">
        <div className="container-custom">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Our Values</p>
            <h2 className="text-heading-lg">What We <span className="italic">Stand For</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: "Excellence", desc: "We use only the most advanced FDA-approved laser technology and maintain the highest standards of care." },
              { title: "Expertise", desc: "Our certified specialist has performed over 5,000 treatments with exceptional results." },
              { title: "Safety", desc: "Your safety is our priority. We follow strict protocols and use gentle, effective techniques." },
              { title: "Care", desc: "We create personalized treatment plans tailored to your unique skin type and goals." },
            ].map((value, index) => (
              <div key={index} className="card-stone p-6" data-testid={`value-${index}`}>
                <h3 className="font-heading text-xl mb-3">{value.title}</h3>
                <p className="text-sm text-muted-foreground">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet Paulo - NEW with updated photo */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-2xl overflow-hidden animate-fade-in-up">
              <img 
                src={IMAGES.pauloNew} 
                alt="Paulo Roberto - Founder of Meo Laser & Skin Studio" 
                className="w-full h-auto"
              />
            </div>
            <div className="space-y-6 animate-fade-in-up animation-delay-200">
              <p className="text-sm uppercase tracking-widest text-muted-foreground">Our Team</p>
              <h2 className="text-heading-lg" data-testid="meet-paulo-title">
                Expert <span className="italic">Specialists</span>
              </h2>
              <p className="text-body" data-testid="paulo-bio-1">
                Our team is composed of certified laser practitioners with specialist training 
                in laser hair removal, vascular treatments, pigmentation correction and skin rejuvenation.
              </p>
              <p className="text-body" data-testid="paulo-bio-2">
                Founder Paulo Roberto, trained in London, brings extensive knowledge and hands-on 
                experience, ensuring every treatment follows the highest UK safety standards and clinical protocols.
              </p>
              <p className="text-body" data-testid="paulo-bio-3">
                At Meo Laser & Skin, professionalism, safety and visible results are our priority.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-muted">
        <div className="container-custom">
          <div className="text-center space-y-6">
            <h2 className="text-heading-lg">Ready to Experience the <span className="italic">Difference?</span></h2>
            <p className="text-body max-w-xl mx-auto">
              Book your free consultation today and let us create a personalized 
              treatment plan just for you.
            </p>
            <a
              href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2"
              data-testid="about-cta-btn"
            >
              Book Free Consultation <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

// Pricing Page
const Pricing = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const packages = [
    {
      name: "Essential",
      price: "£750",
      subtitle: "Course of 6 sessions",
      features: ["Underarms", "Bikini or Buttocks"],
    },
    {
      name: "Complete",
      price: "£1100",
      subtitle: "Course of 6 sessions",
      features: ["Underarms", "Brazilian", "Half Legs", "+ One Small Area of Choice"],
      popular: true,
    },
    {
      name: "Ultimate",
      price: "£1399",
      subtitle: "Course of 6 sessions",
      features: ["Full Body Treatment", "(excludes face)"],
    },
  ];

  const pricingTables = [
    {
      title: "Face & Neck",
      treatments: [
        { name: "Upper Lip", single: "£45", course: "£200" },
        { name: "Chin", single: "£45", course: "£200" },
        { name: "Sides of Face", single: "£65", course: "£290" },
        { name: "Full Face", single: "£120", course: "£540" },
        { name: "Neck (Front or Back)", single: "£65", course: "£290" },
      ],
    },
    {
      title: "Arms & Underarms",
      treatments: [
        { name: "Underarms", single: "£55", course: "£250" },
        { name: "Half Arms", single: "£95", course: "£430" },
        { name: "Full Arms", single: "£145", course: "£650" },
        { name: "Hands & Fingers", single: "£45", course: "£200" },
      ],
    },
    {
      title: "Body",
      treatments: [
        { name: "Chest", single: "£120", course: "£540" },
        { name: "Stomach", single: "£95", course: "£430" },
        { name: "Full Back", single: "£180", course: "£810" },
        { name: "Half Back", single: "£120", course: "£540" },
        { name: "Shoulders", single: "£75", course: "£340" },
      ],
    },
    {
      title: "Legs",
      treatments: [
        { name: "Half Legs (Upper or Lower)", single: "£145", course: "£650" },
        { name: "Full Legs", single: "£250", course: "£1125" },
        { name: "Feet & Toes", single: "£45", course: "£200" },
      ],
    },
    {
      title: "Intimate Areas",
      treatments: [
        { name: "Standard Bikini", single: "£75", course: "£340" },
        { name: "Extended Bikini", single: "£95", course: "£430" },
        { name: "Brazilian", single: "£120", course: "£540" },
        { name: "Hollywood", single: "£140", course: "£630" },
        { name: "Buttocks", single: "£95", course: "£430" },
        { name: "Perianal Area", single: "£85", course: "£408" },
      ],
    },
  ];

  const faqs = [
    { q: "How many sessions do I need?", a: "Most clients need 6-8 sessions for optimal results. This varies depending on hair type, skin tone, and treatment area." },
    { q: "Is laser hair removal painful?", a: "Our Deka Motus Pro laser is virtually pain-free. Most clients describe it as a warm sensation." },
    { q: "How should I prepare for my appointment?", a: "Shave the treatment area 24 hours before your appointment. Avoid sun exposure and tanning for 2 weeks prior." },
    { q: "Are there any side effects?", a: "Mild redness may occur but typically subsides within a few hours. Serious side effects are rare." },
    { q: "Is laser hair removal permanent?", a: "Laser hair removal provides long-lasting results. Most clients see 80-90% permanent hair reduction." },
    { q: "Do you offer payment plans?", a: "Yes, we offer flexible payment plans. Ask during your consultation for more details." },
  ];

  return (
    <div data-testid="pricing-page">
      {/* Hero */}
      <section className="pt-32 pb-16">
        <div className="container-custom text-center">
          <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Pricing</p>
          <h1 className="text-heading-xl mb-4" data-testid="pricing-title">
            Transparent <span className="italic">Pricing</span>
          </h1>
          <p className="text-body max-w-2xl mx-auto">
            We believe in clear, straightforward pricing with no hidden fees. 
            All prices include consultation and aftercare advice.
          </p>
        </div>
      </section>

      {/* Packages */}
      <section className="section-padding bg-muted">
        <div className="container-custom">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Popular Packages</p>
            <h2 className="text-heading-lg">Save with Our <span className="italic">Bundles</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {packages.map((pkg, index) => (
              <div 
                key={index} 
                className={`card-stone p-8 ${pkg.popular ? 'ring-2 ring-[#C4A484]' : ''}`}
                data-testid={`package-${index}`}
              >
                {pkg.popular && (
                  <div className="text-[#C4A484] text-xs font-medium mb-2 uppercase tracking-wider">Most Popular</div>
                )}
                <h3 className="font-heading text-2xl mb-1">{pkg.name}</h3>
                <p className="text-sm text-muted-foreground mb-4">{pkg.subtitle}</p>
                <ul className="space-y-2 mb-6">
                  {pkg.features.map((feature, i) => (
                    <li key={i} className="text-sm text-muted-foreground">{feature}</li>
                  ))}
                </ul>
                <div className="text-3xl font-heading mb-6">{pkg.price}</div>
                <a
                  href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary w-full text-center"
                >
                  Book Now
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Full Price List */}
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Full Price List</p>
            <h2 className="text-heading-lg">Individual <span className="italic">Treatments</span></h2>
            <p className="text-sm text-muted-foreground mt-4">
              Course pricing is for 6 sessions (save up to 25%)
            </p>
          </div>
          
          {pricingTables.map((table, tableIndex) => (
            <div key={tableIndex} className="mb-8" data-testid={`price-table-${tableIndex}`}>
              <h3 className="font-heading text-xl mb-4">{table.title}</h3>
              <div className="card-stone overflow-hidden">
                <div className="grid grid-cols-3 gap-4 p-4 text-sm text-muted-foreground border-b border-border">
                  <div>Treatment</div>
                  <div className="text-center">Single Session</div>
                  <div className="text-center">Course of 6</div>
                </div>
                {table.treatments.map((treatment, i) => (
                  <div key={i} className="grid grid-cols-3 gap-4 p-4 text-sm border-b border-border last:border-0">
                    <div>{treatment.name}</div>
                    <div className="text-center text-muted-foreground">{treatment.single}</div>
                    <div className="text-center text-[#C4A484]">{treatment.course}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="section-padding bg-muted">
        <div className="container-custom max-w-3xl">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">FAQ</p>
            <h2 className="text-heading-lg">Common <span className="italic">Questions</span></h2>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="card-stone overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 text-left"
                  data-testid={`faq-${index}`}
                >
                  <span className="font-medium">{faq.q}</span>
                  <ChevronDown 
                    size={20} 
                    className={`text-muted-foreground transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                  />
                </button>
                {openFaq === index && (
                  <div className="px-4 pb-4 text-sm text-muted-foreground">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding">
        <div className="container-custom text-center">
          <h2 className="text-heading-lg mb-4">Ready to Get <span className="italic">Started?</span></h2>
          <p className="text-body max-w-xl mx-auto mb-8">
            Book your free consultation today. We'll assess your needs and create 
            a personalized treatment plan just for you.
          </p>
          <a
            href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2"
            data-testid="pricing-cta-btn"
          >
            Book Free Consultation <ArrowRight size={16} />
          </a>
        </div>
      </section>
    </div>
  );
};

// Contact Page
const Contact = () => {
  return (
    <div data-testid="contact-page">
      <section className="pt-32 pb-20">
        <div className="container-custom">
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-widest text-muted-foreground mb-4">Contact</p>
            <h1 className="text-heading-xl mb-4" data-testid="contact-title">
              Get In <span className="italic">Touch</span>
            </h1>
            <p className="text-body max-w-2xl mx-auto">
              Have questions? We're here to help. Reach out to us or book a consultation.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div className="card-stone p-8">
                <div className="flex items-start gap-4" data-testid="contact-phone">
                  <div className="w-12 h-12 rounded-full bg-[#D1D9D1] flex items-center justify-center flex-shrink-0">
                    <Phone size={20} />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl mb-1">Phone</h3>
                    <a href="tel:+447767323343" className="text-muted-foreground hover:text-foreground transition-colors">
                      +44 7767 323 343
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="card-stone p-8">
                <div className="flex items-start gap-4" data-testid="contact-location">
                  <div className="w-12 h-12 rounded-full bg-[#D1D9D1] flex items-center justify-center flex-shrink-0">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl mb-1">Location</h3>
                    <p className="text-muted-foreground">14-16 Dowgate Hill</p>
                    <p className="text-muted-foreground">London EC4R 2SU</p>
                    <p className="text-sm text-muted-foreground mt-2">Few meters from Bank Station</p>
                  </div>
                </div>
              </div>

              <a
                href="https://wa.me/447767323343?text=Hi!%20I%27d%20like%20to%20book%20a%20consultation."
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center gap-2 w-full justify-center"
                data-testid="contact-book-btn"
              >
                Book Consultation <ArrowRight size={16} />
              </a>
            </div>

            <div className="rounded-2xl overflow-hidden h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.1234567890123!2d-0.0903!3d51.5118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876034b8e8e8e8e%3A0x1234567890abcdef!2s14-16%20Dowgate%20Hill%2C%20London%20EC4R%202SU!5e0!3m2!1sen!2suk!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Meo Laser & Skin Studio Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// Scroll to top
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F9F7]">
      <BrowserRouter>
        <ScrollToTop />
        <TopBanner />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
